import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-5 pb-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-boldest text-gray-800 fs-2" }, "Teams Progress"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400 fw-bold mt-2 fs-6" }, "890,344 Sales")
], -1)
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = { class: "position-relative pe-6 my-1" }
const _hoisted_5 = { class: "svg-icon svg-icon-3 svg-icon-gray-500 position-absolute top-50 translate-middle ms-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("input", {
  type: "text",
  placeholder: "Search",
  class: "w-150px form-control form-control-sm form-control-solid ps-10"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"my-1\"><select class=\"form-select form-select-sm form-select-solid fw-bolder w-125px\" data-control=\"select2\" data-placeholder=\"All Users\" data-hide-search=\"true\"><option value=\"1\" selected>All Users</option><option value=\"2\">Active users</option><option value=\"3\">Pending users</option></select></div>", 1)
const _hoisted_8 = { class: "card-body py-0" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = {
  class: "table align-middle table-row-bordered table-row-dashed gy-5",
  id: "kt_table_widget_1"
}
const _hoisted_11 = { class: "text-start text-gray-400 fw-boldest fs-7 text-uppercase" }
const _hoisted_12 = { class: "w-20px ps-0" }
const _hoisted_13 = { class: "form-check form-check-sm form-check-custom form-check-solid me-5" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-200px px-0" }, "Authors", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px" }, "Company", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("th", { class: "min-w-125px" }, "Progress", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("th", { class: "text-end pe-2 min-w-70px" }, "Action", -1)
const _hoisted_18 = { class: "p-0" }
const _hoisted_19 = { class: "form-check form-check-sm form-check-custom form-check-solid" }
const _hoisted_20 = ["checked"]
const _hoisted_21 = { class: "p-0" }
const _hoisted_22 = { class: "d-flex align-items-center" }
const _hoisted_23 = { class: "symbol symbol-circle symbol-50px me-2" }
const _hoisted_24 = { class: "symbol-label" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "ps-3" }
const _hoisted_27 = {
  href: "#",
  class: "text-gray-800 fw-boldest fs-5 text-hover-primary mb-1"
}
const _hoisted_28 = { class: "text-gray-400 fw-bold d-block" }
const _hoisted_29 = { class: "text-gray-800 fw-boldest fs-5 d-block" }
const _hoisted_30 = { class: "text-gray-400 fw-bold" }
const _hoisted_31 = { class: "d-flex flex-column w-100 me-2 mt-2" }
const _hoisted_32 = { class: "text-gray-400 me-2 fw-boldest mb-2" }
const _hoisted_33 = { class: "progress bg-light-danger w-100 h-5px" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("td", { class: "pe-0 text-end" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "#",
    class: "btn btn-light text-muted fw-boldest btn-sm px-5"
  }, "View")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen021.svg" })
          ]),
          _hoisted_6
        ]),
        _hoisted_7
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("table", _hoisted_10, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", _hoisted_11, [
              _createElementVNode("th", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _withDirectives(_createElementVNode("input", {
                    class: "form-check-input",
                    type: "checkbox",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.all) = $event))
                  }, null, 512), [
                    [_vModelCheckbox, _ctx.all]
                  ])
                ])
              ]),
              _hoisted_14,
              _hoisted_15,
              _hoisted_16,
              _hoisted_17
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
              return (_openBlock(), _createElementBlock("tr", { key: i }, [
                _createElementVNode("td", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("input", {
                      class: "form-check-input",
                      type: "checkbox",
                      checked: _ctx.all,
                      value: "1"
                    }, null, 8, _hoisted_20)
                  ])
                ]),
                _createElementVNode("td", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("span", _hoisted_24, [
                        _createElementVNode("img", {
                          alt: "",
                          class: "w-25px",
                          src: item.logo
                        }, null, 8, _hoisted_25)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("a", _hoisted_27, _toDisplayString(item.name), 1),
                      _createElementVNode("span", _hoisted_28, _toDisplayString(item.tools), 1)
                    ])
                  ])
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("span", _hoisted_29, _toDisplayString(item.company), 1),
                  _createElementVNode("span", _hoisted_30, _toDisplayString(item.skills), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("span", _hoisted_32, _toDisplayString(item.progress), 1),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", {
                        class: _normalizeClass([`bg-${item.color}`, "progress-bar"]),
                        role: "progressbar",
                        style: _normalizeStyle(`width: ${item.progress}`)
                      }, null, 6)
                    ])
                  ])
                ]),
                _hoisted_34
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ], 2))
}